import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './ui/login/login.component';
import { MainComponent } from './ui/main/main.component';
import { WoodTypificationComponent } from './ui/typification/wood-modal/wood-typification.component';
import { DecimalPipe } from '@angular/common';
import { ImagemodalComponent } from './ui/imagemodal/imagemodal.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthInterceptorService } from './services/auth/auth-interceptor.service';
import { WaitingModalComponent } from './ui/waiting-modal/waiting-modal.component';
import { ConfigService } from './services/config/config.service';
import { LoadTypeSelectionModalComponent } from './ui/typification/load-type-selection-modal/load-type-selection-modal.component';
import { ContainerTypificationComponent } from './ui/typification/container-modal/container-typification.component';

export function initializeApp(configService: ConfigService) {
  return (): Promise<void> => {
    return configService.loadConfig().toPromise();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MainComponent,
    WoodTypificationComponent,
    ContainerTypificationComponent,
    ImagemodalComponent,
    WaitingModalComponent,
    LoadTypeSelectionModalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    },
    DecimalPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
